document.addEventListener('DOMContentLoaded', function () {
  function enforceAccessibleViewport() {
    var desiredContent = 'width=device-width, initial-scale=1'

    function normalizeViewport() {
      var viewportMeta = document.querySelector('meta[name="viewport"]')
      if (!viewportMeta) return
      if (viewportMeta.getAttribute('content') !== desiredContent) {
        viewportMeta.setAttribute('content', desiredContent)
      }
    }

    normalizeViewport()

    var head = document.head
    if (!head || typeof MutationObserver === 'undefined') return

    var observer = new MutationObserver(function () {
      normalizeViewport()
    })

    observer.observe(head, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['content', 'name'],
    })

    setTimeout(normalizeViewport, 1000)
    setTimeout(normalizeViewport, 3000)
  }

  enforceAccessibleViewport()

  document.addEventListener('focusin', function (event) {
    var target = event.target
    if (!(target instanceof HTMLInputElement) || !target.classList.contains('swatch__input')) return

    var focused = document.querySelectorAll('.swatch__input.swatch--has-focus')
    for (var i = 0; i < focused.length; i++) {
      focused[i].classList.remove('swatch--has-focus')
    }

    target.classList.add('swatch--has-focus')
  })

  document.addEventListener('focusout', function (event) {
    var target = event.target
    if (target instanceof HTMLInputElement && target.classList.contains('swatch__input')) {
      target.classList.remove('swatch--has-focus')
    }
  })

  var accordionHeaders = document.querySelectorAll('.accordion-section-header')
  accordionHeaders.forEach(function (header) {
    header.addEventListener('click', function () {
      var expanded = this.getAttribute('aria-expanded') === 'true'
      this.setAttribute('aria-expanded', expanded ? 'false' : 'true')
    })

    header.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault()
        this.click()
      }
    })
  })

  var skipLink = document.querySelector('.skip-link')
  if (skipLink) {
    skipLink.addEventListener('click', function (event) {
      var targetId = skipLink.getAttribute('href').replace('#', '')
      var targetElement = document.getElementById(targetId)
      if (!targetElement) return
      event.preventDefault()
      targetElement.focus()
    })
  }

  var discountInputs = document.querySelectorAll(
    '#scDiscountApp input[type="text"], .ac-new-discounts__input'
  )
  discountInputs.forEach(function (inputField) {
    if (!inputField.getAttribute('aria-label') && (!inputField.labels || inputField.labels.length === 0)) {
      inputField.setAttribute('aria-label', 'Discount code or gift card')
    }
  })

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return
    var cartRoot = document.querySelector('.ac-new--active')
    if (cartRoot) {
      var closeButton = cartRoot.querySelector('.ac-new-header__close')
      if (closeButton) closeButton.click()
    }
  })

  var statusRegion = document.getElementById('a11y-status')

  function announce(message) {
    if (!statusRegion) return
    statusRegion.textContent = ''
    window.setTimeout(function () {
      statusRegion.textContent = message
    }, 100)
  }

  var cartRootEl = document.querySelector('.ac-new')
  if (cartRootEl && typeof MutationObserver !== 'undefined') {
    var wasCartActive = cartRootEl.classList.contains('ac-new--active')
    var cartObserver = new MutationObserver(function () {
      var isCartActive = cartRootEl.classList.contains('ac-new--active')
      if (isCartActive && !wasCartActive) {
        announce('Product added to your cart.')
      }
      wasCartActive = isCartActive
    })
    cartObserver.observe(cartRootEl, { attributes: true, attributeFilter: ['class'] })
  }

  var focusableSelector =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), iframe, [tabindex]:not([tabindex="-1"])'

  function isElementVisible(el) {
    if (!(el instanceof HTMLElement)) return false
    if (el.disabled) return false
    if (el.getAttribute('aria-hidden') === 'true') return false
    if (el.getAttribute('tabindex') === '-1') return false

    var style = window.getComputedStyle(el)
    if (style.display === 'none' || style.visibility === 'hidden') return false

    return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement
  }

  function isNaturallyFocusable(el) {
    if (!(el instanceof HTMLElement) || el.disabled) return false

    var tag = el.tagName
    if (tag === 'A' && el.hasAttribute('href')) return true
    if (tag === 'BUTTON') return true
    if (tag === 'INPUT' || tag === 'SELECT' || tag === 'TEXTAREA') return true
    if (tag === 'IFRAME') return true

    var tabindex = el.getAttribute('tabindex')
    return tabindex !== null && tabindex !== '-1'
  }

  function isWithinContainer(container, el) {
    if (!container || !el) return false
    if (container.contains(el)) return true

    var root = el.getRootNode()
    if (root instanceof ShadowRoot && root.host) {
      return isWithinContainer(container, root.host)
    }

    return false
  }

  function collectFocusables(root, results) {
    if (!root) return

    var matches = root.querySelectorAll(focusableSelector)
    for (var i = 0; i < matches.length; i++) {
      if (isElementVisible(matches[i])) results.push(matches[i])
    }

    var elements = root.querySelectorAll('*')
    for (var j = 0; j < elements.length; j++) {
      if (elements[j].shadowRoot) collectFocusables(elements[j].shadowRoot, results)
    }
  }

  function getContainerFocusables(container) {
    var focusable = []
    collectFocusables(container, focusable)

    focusable = focusable.filter(function (el) {
      return !el.hasAttribute('data-focus-sentinel')
    })

    focusable.sort(function (a, b) {
      if (a === b) return 0
      var position = a.compareDocumentPosition(b)
      if (position & Node.DOCUMENT_POSITION_FOLLOWING) return -1
      if (position & Node.DOCUMENT_POSITION_PRECEDING) return 1
      return 0
    })

    return focusable.filter(function (el, index, list) {
      return list.indexOf(el) === index
    })
  }

  function enhanceThirdPartyCheckoutButtons(container) {
    if (!container) return

    var candidates = []

    function walk(parent) {
      var elements = parent.querySelectorAll('*')
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].shadowRoot) walk(elements[i].shadowRoot)
      }

      for (var j = 0; j < elements.length; j++) {
        var el = elements[j]
        if (!(el instanceof HTMLElement)) continue
        if (isNaturallyFocusable(el)) continue
        if (el.getAttribute('data-a11y-enhanced') === 'true') continue

        var text = (el.textContent || '').replace(/\s+/g, ' ').trim()
        if (!/checkout\+/i.test(text) || text.length > 80) continue

        var rect = el.getBoundingClientRect()
        if (rect.height < 24 || rect.width < 80) continue

        candidates.push(el)
      }
    }

    walk(container)

    candidates
      .filter(function (el) {
        return !candidates.some(function (other) {
          return other !== el && el.contains(other)
        })
      })
      .forEach(function (target) {
        target.setAttribute('data-a11y-enhanced', 'true')
        target.setAttribute('tabindex', '0')
        if (!target.getAttribute('role')) target.setAttribute('role', 'button')

        if (!target.getAttribute('aria-label')) {
          target.setAttribute('aria-label', (target.textContent || '').replace(/\s+/g, ' ').trim())
        }

        target.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            target.click()
          }
        })
      })
  }

  // Native controls already get a :focus-visible ring from global.css.
  // For third-party wallets (Shop Pay, Redo "Checkout+") the focusable control
  // lives inside a closed shadow root we can't style, so we mark the visible
  // HOST element (a custom element, i.e. its tag name contains a hyphen) and
  // draw the ring on that instead.
  function isCheckoutFocusHost(node, footer) {
    if (!(node instanceof HTMLElement) || !footer.contains(node)) return false
    if (node === footer) return false
    if (node.matches('button[name="checkout"], [data-a11y-enhanced]')) return true
    // Any custom element (e.g. shop-pay-wallet-button, redo-shopify-toggle,
    // and whatever element Redo uses for its Checkout+ button).
    return node.tagName.indexOf('-') !== -1
  }

  function clearCheckoutFocusRings(footer) {
    var marked = footer.querySelectorAll('.a11y-host-focus')
    for (var i = 0; i < marked.length; i++) {
      marked[i].classList.remove('a11y-host-focus')
    }
  }

  function attachCheckoutFocusRings(footer) {
    if (!footer || footer.getAttribute('data-a11y-checkout-focus')) return
    footer.setAttribute('data-a11y-checkout-focus', 'true')

    footer.addEventListener('focusin', function (event) {
      clearCheckoutFocusRings(footer)

      var path = typeof event.composedPath === 'function' ? event.composedPath() : [event.target]

      // Walk from the focused node outward and mark the innermost host element.
      for (var i = 0; i < path.length; i++) {
        if (isCheckoutFocusHost(path[i], footer)) {
          path[i].classList.add('a11y-host-focus')
          return
        }
      }
    })

    footer.addEventListener('focusout', function () {
      window.requestAnimationFrame(function () {
        if (!footer.contains(document.activeElement)) clearCheckoutFocusRings(footer)
      })
    })
  }

  function prepareAcceleratedCheckoutWallets(container) {
    if (!container) return

    var footer = container.querySelector('.ac-new-footer')
    if (footer) attachCheckoutFocusRings(footer)

    var frames = container.querySelectorAll('.ac-new-footer__dynamic-checkout iframe')
    for (var i = 0; i < frames.length; i++) {
      var frame = frames[i]
      if (!(frame instanceof HTMLElement) || !isElementVisible(frame)) continue
      if (!frame.getAttribute('title') && !frame.getAttribute('aria-label')) {
        frame.setAttribute('title', 'Shop Pay')
      }
    }
  }

  // The cart's checkout wallets (Shop Pay) and Redo "Checkout+" render inside
  // CLOSED shadow roots, which JS cannot enumerate. The browser's native Tab
  // order still walks into them, so instead of computing the last focusable
  // element ourselves (which misses those widgets and traps focus too early),
  // we place focusable sentinels at the very start and end of the dialog and
  // let native tabbing flow through everything in between.
  var sentinelStyle =
    'position:absolute;width:1px;height:1px;margin:-1px;padding:0;border:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;'

  function makeSentinel(position, container) {
    var sentinel = document.createElement('span')
    sentinel.setAttribute('data-focus-sentinel', position)
    sentinel.tabIndex = 0
    sentinel.style.cssText = sentinelStyle

    sentinel.addEventListener('focus', function () {
      var focusables = getContainerFocusables(container)
      if (!focusables.length) return
      var target = position === 'start' ? focusables[focusables.length - 1] : focusables[0]
      if (target) target.focus()
    })

    return sentinel
  }

  function ensureSentinels(container) {
    if (!container) return

    var start = container.querySelector(':scope > [data-focus-sentinel="start"]')
    if (!start) {
      start = makeSentinel('start', container)
      container.insertBefore(start, container.firstChild)
    } else if (container.firstChild !== start) {
      container.insertBefore(start, container.firstChild)
    }

    var end = container.querySelector(':scope > [data-focus-sentinel="end"]')
    if (!end) {
      end = makeSentinel('end', container)
      container.appendChild(end)
    } else if (container.lastChild !== end) {
      container.appendChild(end)
    }
  }

  function watchCartCheckoutButtons() {
    var cartRoot = document.querySelector('.ac-new')
    if (!cartRoot || typeof MutationObserver === 'undefined') return

    var enhance = function () {
      if (!cartRoot.classList.contains('ac-new--active')) return
      var cartBox = cartRoot.querySelector('.ac-new__box')
      if (!cartBox) return
      enhanceThirdPartyCheckoutButtons(cartBox)
      prepareAcceleratedCheckoutWallets(cartBox)
      ensureSentinels(cartBox)
    }

    enhance()

    var observer = new MutationObserver(function () {
      enhance()
    })

    observer.observe(cartRoot, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    })
  }

  watchCartCheckoutButtons()

  var initialCartFooter = document.querySelector('.ac-new-footer')
  if (initialCartFooter) attachCheckoutFocusRings(initialCartFooter)

  function getElementAccessibleName(el) {
    if (!(el instanceof HTMLElement)) return ''

    var labelledBy = el.getAttribute('aria-labelledby')
    if (labelledBy) {
      var labelEl = document.getElementById(labelledBy)
      if (labelEl) return (labelEl.textContent || '').replace(/\s+/g, ' ').trim()
    }

    var text = (el.textContent || '').replace(/\s+/g, ' ').trim()
    if (text) return text

    var img = el.querySelector('img[alt]')
    if (img) return (img.getAttribute('alt') || '').trim()

    return ''
  }

  function enhanceYotpoWidgets(root) {
    var scope = root || document
    var tabs = scope.querySelectorAll('[role="tab"]')

    for (var i = 0; i < tabs.length; i++) {
      var tab = tabs[i]
      if (!(tab instanceof HTMLElement)) continue

      var controlsId = tab.getAttribute('aria-controls')
      if (controlsId && !document.getElementById(controlsId)) {
        tab.removeAttribute('aria-controls')
      }

      var selected = tab.getAttribute('aria-selected')
      if (selected !== null && selected !== 'true' && selected !== 'false') {
        var isSelected =
          tab.classList.contains('selected') ||
          tab.classList.contains('active') ||
          tab.getAttribute('aria-selected') === 'true'
        tab.setAttribute('aria-selected', isSelected ? 'true' : 'false')
      }

      if (!tab.getAttribute('id')) {
        tab.setAttribute('id', 'yotpo-tab-a11y-' + i)
      }
    }

    var panels = scope.querySelectorAll('[role="tabpanel"]')
    for (var j = 0; j < panels.length; j++) {
      var panel = panels[j]
      if (!(panel instanceof HTMLElement)) continue
      if (!panel.id) panel.setAttribute('id', 'yotpo-tabpanel-a11y-' + j)
      if (!panel.getAttribute('tabindex')) panel.setAttribute('tabindex', '0')
    }
  }

  function enhanceEnviveWidget(root) {
    if (!root) return

    var headings = root.querySelectorAll('h4, h5, h6')
    for (var i = 0; i < headings.length; i++) {
      var heading = headings[i]
      if (heading.getAttribute('data-a11y-enhanced-heading')) continue
      heading.setAttribute('data-a11y-enhanced-heading', 'true')
      if (getElementAccessibleName(heading)) {
        heading.setAttribute('role', 'heading')
        heading.setAttribute('aria-level', '2')
      } else {
        heading.setAttribute('role', 'presentation')
      }
    }

    var buttons = root.querySelectorAll('[role="button"], [tabindex="0"]')
    for (var j = 0; j < buttons.length; j++) {
      var btn = buttons[j]
      if (!(btn instanceof HTMLElement)) continue
      if (btn.tagName === 'BUTTON' || btn.tagName === 'A') continue
      if (btn.getAttribute('role') !== 'button' && btn.getAttribute('tabindex') !== '0') continue
      if (btn.getAttribute('aria-label') || btn.getAttribute('aria-labelledby')) continue

      var name = getElementAccessibleName(btn)
      if (!name && btn.getAttribute('aria-expanded') !== null) {
        name = btn.getAttribute('aria-expanded') === 'true' ? 'Collapse section' : 'Expand section'
      }
      if (!name) name = 'Show options'
      if (name.length > 120) name = name.slice(0, 120)

      btn.setAttribute('role', 'button')
      btn.setAttribute('aria-label', name)
    }
  }

  var thirdPartyEnhanceTimer
  function scheduleThirdPartyEnhancements() {
    if (thirdPartyEnhanceTimer) window.clearTimeout(thirdPartyEnhanceTimer)
    thirdPartyEnhanceTimer = window.setTimeout(function () {
      enhanceYotpoWidgets(document)

      var enviveWrap = document.querySelector('.envive-pdp-widget-wrap')
      if (enviveWrap) enhanceEnviveWidget(enviveWrap)

      var enviveRoot = document.getElementById('envive-pdp-widget-small')
      if (enviveRoot) enhanceEnviveWidget(enviveRoot)

      var envivePreview = document.getElementById('spiffy-ai-chat-preview')
      if (envivePreview) enhanceEnviveWidget(envivePreview)
    }, 200)
  }

  function watchThirdPartyWidgets() {
    if (typeof MutationObserver === 'undefined') return

    scheduleThirdPartyEnhancements()

    var observer = new MutationObserver(function () {
      scheduleThirdPartyEnhancements()
    })

    observer.observe(document.body, { childList: true, subtree: true })
  }

  watchThirdPartyWidgets()

  var productVideos = document.querySelectorAll('.embla__slide video, .main-product-new video')
  for (var v = 0; v < productVideos.length; v++) {
    var video = productVideos[v]
    if (!(video instanceof HTMLVideoElement)) continue
    if (!video.getAttribute('aria-label') && !video.getAttribute('title')) {
      video.setAttribute('aria-label', 'Product demonstration video')
    }
  }

  function getActiveModalContainer() {
    var activeCart = document.querySelector('.ac-new--active .ac-new__box')
    if (activeCart) return activeCart

    // Only trap focus in the mobile nav when it was opened via the hamburger
    // (the same drawer markup is reused as a hover preview on desktop).
    var hamburger = document.querySelector('.hamburger')
    if (hamburger && hamburger.getAttribute('aria-expanded') === 'true') {
      var activeNav = document.querySelector('.nav-drawer--primary.nav-drawer--active .nav-drawer__box')
      if (activeNav) return activeNav
    }

    return null
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab') return

    var container = getActiveModalContainer()
    if (!container) return

    enhanceThirdPartyCheckoutButtons(container)
    prepareAcceleratedCheckoutWallets(container)
    ensureSentinels(container)

    // If focus is somewhere outside the open dialog, pull it back inside.
    // Otherwise let the browser tab naturally (including into closed shadow
    // DOM wallets); the boundary sentinels handle wrapping.
    if (!isWithinContainer(container, document.activeElement)) {
      var focusables = getContainerFocusables(container)
      event.preventDefault()
      if (focusables.length) {
        focusables[0].focus()
      } else {
        if (!container.hasAttribute('tabindex')) container.setAttribute('tabindex', '-1')
        container.focus()
      }
    }
  })
})
